<template>
  <tbody>
  <tr class="table-row-style">
    <td v-if="isUpdateMode">
      <NumberInputField
          class="w-50 d-inline-block" v-model="updatedPartTimePercentage.percentage"
          labelText="percentage"
          :hideLabel="true" required
          minValue="0" maxValue="100"/>
    </td>
    <td v-else :style="color()">{{ partTimePercentage.percentage }}</td>

    <td v-if="isUpdateMode">
      <DateInputField
          class="w-50 d-inline-block" v-model="updatedPartTimePercentage.startDate"
          @input="updateIfInvalidDate"
          labelText="startDatum"
          :before-date="nextElement ? nextElement.endDate : '' "
          :after-date="prevElement ? prevElement.startDate : '' "
          noLabel/>
      <DateInputField
          class="w-50 d-inline-block" v-model="updatedPartTimePercentage.endDate"
           @input="updateIfInvalidDate"
          labelText="einddatum"
          noLabel
          :before-date="nextElement ? nextElement.endDate : '' " 
          :afterDate="startDateFormatted()"/>
    </td>
    <td v-else :style="color()">
      <span :style="colorStartDate()">{{ partTimePercentage.startDate }}</span>
      <span :style="colorEndDate()">{{ partTimePercentage.endDate ? " tot " + partTimePercentage.endDate : " tot heden" }}</span>
    </td>
    <td class="btn-group">
      <button
          v-show="!isUpdateMode && !isConfirming"
          class="btn-basic btn-outline-pulse w-auto mr-2" @click="toggleUpdateMode">
        Datums aanpassen
      </button>
      <button
          :disabled="isSaving" v-show="isConfirming"
          class="btn-basic btn-fill-pulse mr-2" @click="save">
        Opslaan
      </button>
      <button
          :disabled="isSaving || isDateWrong" v-show="isUpdateMode"
          class="btn-basic btn-fill-pulse mr-2" @click="confirm">
        Toon aanpassingen
      </button>
      <button
          :disabled="isSaving" v-show="isConfirming || isUpdateMode"
          class="btn-basic btn-fill-pulse-dark" @click="cancel">
        Annuleren
      </button>
    </td>
  </tr>
  </tbody>
</template>

<script>

import DateInputField from "@/components/inputFields/DateInputField";
import {toYearAndMonthAndDay} from "@/util/DateUtil";
import {mapActions} from "vuex";
import NumberInputField from "@/components/inputFields/NumberInputField.vue";

export default {
  name: "PartTimePercentageTableRowComponent",
  components: {
    NumberInputField,
    DateInputField
  },
  props: ['partTimePercentage','prevElement', 'nextElement'],
  data: () => ({
    isDateWrong: false,
    isConfirming: false,
    isSaving: false,
    isUpdateMode: false,
    defaultPercentage : undefined,
    defaultStartDate : undefined,
    defaultEndDate : undefined,
    updatedPartTimePercentage: {
      startDate:undefined,
      endDate:undefined,
      percentage: undefined
    },
  }),
  created() {
    this.defaultPercentage = this.partTimePercentage.percentage;
    this.defaultStartDate = this.partTimePercentage.startDate;
    this.defaultEndDate = this.partTimePercentage.endDate;
  },
  methods: {
    ...mapActions("administrationUser", ["updatePartTimePercentage"]),
    startDateFormatted() { 

      return toYearAndMonthAndDay(this.updatedPartTimePercentage.startDate);
    },
    color() {
      return this.isConfirming ? { color: 'red' } : {};
    },
    colorEndDate() {
      return this.partTimePercentage.highlightEndDate ? { color: 'red' } : {};
    },
    colorStartDate() {
      return this.partTimePercentage.highlightStartDate ? { color: 'red' } : {};
    },
    cancel() {
      this.isUpdateMode = false;
      this.isConfirming = false;
      this.updatedPartTimePercentage.startDate = this.defaultStartDate;
      this.updatedPartTimePercentage.endDate = this.defaultEndDate;
      this.updatedPartTimePercentage.percentage = this.defaultPercentage;
      this.updatePreviousElement(this.defaultStartDate, false);
      this.updateNextElement(this.defaultEndDate, false);
      this.resetCurrentElement();
    },
    toggleUpdateMode() {
      this.isUpdateMode = !this.isUpdateMode;
      this.updatedPartTimePercentage.startDate = this.defaultStartDate;
      this.updatedPartTimePercentage.endDate = this.defaultEndDate;
      this.updatedPartTimePercentage.percentage = this.defaultPercentage;
    },
    updatePreviousElement(date, color) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() - 1);
      const newPrevElement = {...this.prevElement, endDate: toYearAndMonthAndDay(newDate), highlightEndDate: color};
      this.$emit('update-prev-element', newPrevElement);
    },
    updateNextElement(date, color) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + 1);
      const newNextElement = {...this.nextElement, startDate: toYearAndMonthAndDay(newDate), highlightStartDate: color};
      this.$emit('update-next-element', newNextElement);
    },
    updateCurrentElement() {
      const newCurrentElement = {...this.partTimePercentage, percentage: this.updatedPartTimePercentage.percentage, startDate: this.updatedPartTimePercentage.startDate, endDate: this.updatedPartTimePercentage.endDate};
      this.$emit('update-current-element', newCurrentElement);
    },
    resetCurrentElement() {
      const newCurrentElement = {...this.partTimePercentage, percentage: this.defaultPercentage, startDate: this.defaultStartDate, endDate: this.defaultEndDate};
      this.$emit('update-current-element', newCurrentElement);
    },
    confirm() {
      this.updatePreviousElement(this.updatedPartTimePercentage.startDate, true);
      this.updateNextElement(this.updatedPartTimePercentage.endDate, true);
      this.updateCurrentElement();
      this.isUpdateMode = false;
      this.isConfirming = true;
    },
    save() {
      this.isSaving = true;
      const updatePartTimePercentageDto = {
        id: this.partTimePercentage.id,
        startDate: this.updatedPartTimePercentage.startDate,
        endDate: this.updatedPartTimePercentage.endDate,
        percentage: this.updatedPartTimePercentage.percentage
      };
      this.updatePartTimePercentage(updatePartTimePercentageDto)
        .then(() => {
          this.isSaving = false;
          this.isConfirming = false;
          this.isUpdateMode = false;
          this.updatePreviousElement(this.updatedPartTimePercentage.startDate, false);
          this.updateNextElement(this.updatedPartTimePercentage.endDate, false);
        }).catch(() => {
        this.isSaving = false;
        this.isConfirming = false;
        this.isUpdateMode =false;
      });
    },
    updateIfInvalidDate(){
      const startDate = this.updatedPartTimePercentage.startDate;
      const endDate = this.updatedPartTimePercentage.endDate;
      this.isDateWrong = (startDate >= endDate && endDate != null);
    }
  }
};
</script>

<style scoped>
.height {
  height: 65px;
}
</style>